export default __webpack_public_path__ + "static/invisi-h-f7789e9901aedcb430fca609180b9a38.jpg";